export const GET_LIST = 'bug/GET_LIST';
export const CHANGELIST = 'buy/CHANGELIST';
export const CHANGETIME = 'buy/CHANGETIME';
export const SUBMIT = 'buy/SUBMIT';
export const ABNORMAL = 'buy/ABNORMAL';
export const HANDLEOK = 'buy/HANDLEOK';
export const HANDLE_CANCEL = 'buy/HANDLE_CANCEL';
export const SUBMIT_LOADINGTRUE = 'buy/SUBMIT_LOADINGTRUE';
export const SUBMIT_LOADINGFALSE = 'buy/SUBMIT_LOADINGFALSE';